import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Button } from 'react-bootstrap';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function AhtapotOptionsInfoModal({ open, handleClose, handleAcceptDialog, ahtapotAbonelikAktiflestirmeDto = {} }) {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="ahtapot-options-dialog-title"
            maxWidth="md"
            fullWidth
        >

            <DialogTitle id="responsive-dialog-title" style={{border: '1px solid #dee2e6', color: "darkblue", paddingBottom:"6px"}}>
                <div style={{display: "grid"}}>
                    <div>
                        <p style={{
                            verticalAlign: 'middle',
                            float: 'left',
                            fontSize: 30,
                            margin: 0,
                            paddingTop: 8
                        }}>{'Onay'}</p>
                        <InfoOutlinedIcon style={{fontSize: 60, float: 'right'}}/>
                    </div>
                    <div style={{fontSize: '15px', fontWeight: "bolder", color: "black"}}>{'Ahtabot Atama Tercihlerinde;'}</div>
                </div>
            </DialogTitle>
            <DialogContent style={{paddingTop: '10px', paddingBottom: '10px'}}>
                <DialogContentText key={1} style={{marginBottom: '15px', color:"black"}}>
                    <strong>{"Ahtabot, En Son Açılmış Derdest Dosyalardan Başlayarak Otomatik Seçsin mi?:"}</strong>
                    <span style={{fontStyle: "italic"}}>{"\"" + (ahtapotAbonelikAktiflestirmeDto?.acikDosyaAhtapotOtomatikTercihTipiDto?.name || '') + "\""}</span>
                </DialogContentText>
                <DialogContentText key={2} style={{marginBottom: '15px', color: "black"}}>
                    <strong>{"Ahtabot, İnfaz Dosyalarda, Avans/Tahsilat Reddiyat Kontrolü İçin En Son Kapanmış Dosyalardan Başlayarak Otomatik Seçsin mi?:"}</strong>
                    <span style={{fontStyle: "italic"}}>{"\"" + (ahtapotAbonelikAktiflestirmeDto?.kapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipiDto?.name || '') + "\""}</span>
                </DialogContentText>
                <DialogContentText key={3} style={{marginBottom: '20px', color: "black"}}>
                    <strong>{"Ahtabot,  Yenilenebilir Düşmüş Dosyaları,  En Son Kapanmış Dosyalardan Başlayarak Otomatik Seçsin mi?:"}</strong>
                    <span style={{fontStyle: "italic"}}>{"\"" + (ahtapotAbonelikAktiflestirmeDto?.kapaliYenilenebilirDosyaAhtapotOtomatikTercihTipiDto?.name || '') + "\""}</span>
                </DialogContentText>
                <DialogContentText  style={{marginBottom: '15px', color: "black"}}>
                    <strong>{"seçimlerini yaptınız. Bu tercihlerle devam etmek istiyor musunuz?"}</strong>
                </DialogContentText>
                <DialogContentText style={{fontStyle: "italic"}}>
                    {"Devam Etmek İstemiyorsanız 'Ahtabot Atama Tercihleri' alanından gerekli değişiklikleri yapabilirsiniz."}
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{borderTop: '1px solid #dee2e6'}}>
                <Button onClick={handleAcceptDialog} variant="info" autoFocus>
                    Evet
                </Button>
                <Button onClick={handleClose} variant="secondary">
                    Hayır
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AhtapotOptionsInfoModal;
